export default [
  {
    url: '/Dashboard/abstract',
    slug: 'ScaCustomer_Dashboard',
    i18n: 'UserDashboard',
    icon: 'AwardIcon'
  },
  {
    url: '/dashboard',
    slug: 'dashboard',
    icon: 'LayersIcon',
    i18n: 'MyDashboard',
    submenu: [
      {
        url: '/dashboard/Profile',
        slug: 'ScaCustomer_Profile',
        i18n: 'Profile'
      },
      {
        url: '/dashboard/AccountList',
        slug: 'ScaCustomer_AccountList',
        i18n: 'Accounts'
      }
          
    ]
  },
  {
    url: '/transaction',
    slug: 'transaction',
    icon: 'DollarSignIcon',
    i18n: 'Transaction',
    submenu: [
      {
        url: '/transaction/history',
        slug: 'transactionHistory',
        i18n: 'History'
      },
      {
        url: '/transaction/deposit/add',
        slug: 'makeDeposit',
        i18n: 'Deposit'
      },
      {
        url: '/transaction/withdrawal/add',
        slug: 'makeWithdrawal',
        i18n: 'Withdrawal'
      },
      {
        url: '/transaction/transfer/add',
        slug: 'makeTransfer',
        i18n: 'Transfer'
      }
    ]
  },
  {
    header: 'Settings Management',
    i18n: 'SettingsManagement',
    items: [
      {
        slug: 'Settings',
        icon: 'SettingsIcon',
        i18n: 'Theme Config',
        url: '/settings/thecustomizer'
      }
    ]
  }
]
